module.exports = __webpack_public_path__ + "img/斑蝥.13878f42.jpg";